import { render, staticRenderFns } from "./Intelligent.vue?vue&type=template&id=39ba485d&scoped=true&"
import script from "./Intelligent.vue?vue&type=script&lang=js&"
export * from "./Intelligent.vue?vue&type=script&lang=js&"
import style0 from "./Intelligent.vue?vue&type=style&index=0&id=39ba485d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ba485d",
  null
  
)

export default component.exports